import * as React from 'react';

const SVGArrowRight: React.SFC<SvgProps> = props => (
  <svg width={20} height={11} {...props}>
    <g
      stroke="#000"
      strokeWidth={1.5}
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M11.17 9.597l7.179-4.178-7.02-4.15M17.5 5.5H1.375" />
    </g>
  </svg>
);

export default SVGArrowRight;
